import {
  ADD_EVENT_TO_BETSLIP_SUCCESS,
  POST_REGISTER_SUCCESS,
  PLAY_COUPON_SUCCESS,
} from 'Store/constants';

import {
  completeRegistrationEvent,
  addToCartEvent,
  purchaseEvent,
} from 'Utils/fbAppEvents';
import {
  initFacebookSdk,
} from 'Utils/thirdParty/marketingToolScripts';

const FACEBOOK_TRACKED_TYPES = [POST_REGISTER_SUCCESS, ADD_EVENT_TO_BETSLIP_SUCCESS, PLAY_COUPON_SUCCESS];

export const fbAppEventsCollector = () => {
  return next => action => {
    const returnValue = next(action);

    if (FACEBOOK_TRACKED_TYPES.includes(action.type)) {
      initFacebookSdk()
        .then(() => {
          if (action.type === POST_REGISTER_SUCCESS) {
            completeRegistrationEvent('form');
          }

          if (action.type === ADD_EVENT_TO_BETSLIP_SUCCESS) {
            const { payload } = action;
            const [odd] = payload.eventDetails.bets;

            addToCartEvent(
              payload.eventDetails.name,
              payload.event.eventId,
              odd.marketName,
              'TRY',
              +odd.odd
            );
          }

          if (action.type === PLAY_COUPON_SUCCESS) {
            const { coupon } = action.payload;
            purchaseEvent(coupon.couponCost, 'TRY', coupon.transactionId);
          }
        })
        .catch(() => {
          // expected behaviour – do nothing
        });
    }

    return returnValue;
  };
};
